import clsx from 'clsx'

import { ActionsProps, ActionType } from './types'
import { useActions } from './useActions'
import styles from './Actions.module.scss'
import { Button } from '../common'
import { POI, Scene } from '../../shared/types'

const Actions = (props: ActionsProps) => {
  const { actions } = props
  const { handlers } = useActions()

  if (actions.length === 0) return null

  return (
    <div className={styles.actionsRoot}>
      {actions.map(({ id, label, fullData, type, visited, locked }) => {
        let onClick: () => void

        switch (type) {
          case ActionType.POI:
            onClick = () => handlers.handlePOIClick(fullData as POI)
            break
          case ActionType.SCENE:
            onClick = () => handlers.handleSceneClick(fullData as Scene)
            break
          default:
            onClick = () => console.warn('Unknown type:', type)
            break
        }

        return (
          <Button
            key={id}
            type="button"
            className={clsx(
              styles.actionButton,
              visited && !locked && styles.visited,
              visited && locked && styles.visitedAndLocked
            )}
            onClick={onClick}
          >
            {label}
          </Button>
        )
      })}
    </div>
  )
}

export default Actions
